// Ce module a pour but de simplifier le dialogue avec les LocalDate and LocalDateTime de java
// LocalDate et LocalDateTime sont utilises pour eviter les decalages entre le client et le serveur quand ils n'ont pas les memes reglage horaires
// Ils se traduisent tous deux comme des type number [] en JS

import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules material utilises
import { MatDatepickerModule } from '@angular/material/datepicker';

// Autres modules externes utilises 
import {
	NgxMatNativeDateModule,
	NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';

// Composants graphiques
import { DateInputComponent } from './components/date-input.component';
import { TimeInputComponent } from './components/time-input.component';
import { WeekInputComponent } from './components/week-input.component';

// Services metier
import { JSR310ConversionService } from './services/jsr310-conversion.service';

// Pipes
import { DisplayLocalDatePipe } from './pipes/display-local-date.pipe';
import { DisplayLocalTimeWithoutSecondsPipe } from './pipes/display-local-time-without-seconds.pipe';
import { LocalDateTimeToDatePipe } from './pipes/local-date-time-to-date.pipe';
import { LocalDateToDatePipe } from './pipes/local-date-to-date.pipe';

// Bridges avec la partie anguler
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatDatepickerModule,

		NgxMatNativeDateModule,
		NgxMatTimepickerModule,
	],
	providers: [
		JSR310ConversionService,
	],
	declarations: [
		DateInputComponent,
		TimeInputComponent,
		WeekInputComponent,

		DisplayLocalDatePipe,
		DisplayLocalTimeWithoutSecondsPipe,
		LocalDateTimeToDatePipe,
		LocalDateToDatePipe,
	],
	exports: [
		DateInputComponent,
		TimeInputComponent,
		WeekInputComponent,

		DisplayLocalDatePipe,
		DisplayLocalTimeWithoutSecondsPipe,
		LocalDateTimeToDatePipe,
		LocalDateToDatePipe,
	]
})
export class JSR310LocalDatesModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('weekInput',
		downgradeComponent({ component: WeekInputComponent })
	) //
